import { useMutation } from "@tanstack/react-query";
import { lookupProviderFax } from "#/api/providers.api";
import { getErrorMessage } from "#/api/api-errors";
import { formatPhoneNumberToHumanReadable } from "#/components/utls/utils";
import { useToast } from "./ToastContext";

export type LookupProviderFaxVariables = {
  providerId?: string;
  institutionId?: string;
};

export function useLookupProviderFax() {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: async ({ providerId, institutionId }: LookupProviderFaxVariables) => {
      if (!providerId && !institutionId) {
        throw new Error("A provider or institution ID is required");
      }

      return lookupProviderFax({ providerId, institutionId });
    },
    onSuccess: ({ fax }) => {
      if (fax) {
        const formattedFax = formatPhoneNumberToHumanReadable(fax);
        showToast(`Fax found: ${formattedFax || fax}`, "success");
      } else {
        showToast("No fax found for this provider", "info");
      }
    },
    onError: (error) => {
      showToast(getErrorMessage(error), "error");
    },
  });
}

export default useLookupProviderFax;
